import { Grid, Tooltip } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const BalanceTooltipStyles = makeStyles((theme: Theme) =>
  createStyles({
    arrow: {
      color: (contrast) => (contrast ? "#324E61" : theme.palette.primary.main),
    },
    tooltip: {
      backgroundColor: (contrast) => (contrast ? "#324E61" : theme.palette.primary.main),
    },
    popper: {
      opacity: (contrast) => (contrast ? 1 : 0.8),
    },
  }),
);

interface BalanceTooltipProps {
  message: string;
  children: JSX.Element;
  ignoreGrid?: boolean;
  show?: boolean;
  align?:
    | "bottom"
    | "left"
    | "right"
    | "top"
    | "top-start"
    | "bottom-end"
    | "bottom-start"
    | "left-end"
    | "left-start"
    | "right-end"
    | "right-start"
    | "top-end"
    | undefined;
  contrast?: boolean;
  id?: string;
}

const BalanceTooltip = (props: BalanceTooltipProps) => {
  const { message, children, align, contrast = false, ignoreGrid, show = true, id } = props;
  const classes = BalanceTooltipStyles(contrast);
  if (!show) return <>{children}</>;
  return (
    <Tooltip
      id={id}
      arrow
      placement={align ?? "top-start"}
      classes={{
        arrow: classes.arrow,
        tooltip: classes.tooltip,
        popper: classes.popper,
      }}
      disableFocusListener
      PopperProps={{
        disablePortal: true,
      }}
      title={
        <div
          style={{
            fontSize: "14px",
            color: "#F8F9F9",
            margin: "2px",
            alignItems: "center",
          }}>
          {message}
        </div>
      }>
      {ignoreGrid ? (
        children
      ) : (
        <Grid
          style={{
            cursor: "pointer",
            height: "fit-content",
            width: "fit-content",
            display: "flex",
          }}>
          {children}
        </Grid>
      )}
    </Tooltip>
  );
};

export default BalanceTooltip;
